export default __webpack_public_path__ + "static/media/my-stats.0caee6cb.svg";